import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getWarehouseList as getWarehouseListApi,
	getWarehouse as getWarehouseApi,
	addNewWarehouse as addNewWarehouseApi,
	updateWarehouse as updateWarehouseApi,
	deleteWarehouse as deleteWarehouseApi,
	synchronizeWarehouse as synchronizeWarehouseApi,
	synchronizeWarehouseItems as synchronizeWarehouseItemsApi,
	synchronizeWarehouseGroup as synchronizeWarehouseGroupApi,
	getWarehouseByEstablishment as getWarehouseByEstablishmentApi,
	getWarehouseGroupExist as getWarehouseGroupExistApi,
} from '../../helpers/warehouse/backend_helper';

export const getWarehouseList = createAsyncThunk('warehouses/getWarehouseList', async () => {
	try {
		const response = getWarehouseListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getWarehouse = createAsyncThunk('warehouses/getWarehouse', async warehouse_id => {
	try {
		const response = getWarehouseApi(warehouse_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});


export const getWarehouseByEstablishment = createAsyncThunk('warehouses/getWarehouseByEstablishment', async establishment_id => {
	try {
		const response = getWarehouseByEstablishmentApi(establishment_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});


export const addNewWarehouse = createAsyncThunk('warehouses/addNewWarehouse', async warehouse => {
	try {
		const response = addNewWarehouseApi(warehouse);
		toast.success('Bodega agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar warehouse.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateWarehouse = createAsyncThunk('warehouses/updateWarehouse', async (warehouse) => {
	try {
		const response = updateWarehouseApi(warehouse);
		toast.success('Bodega actualizado exitosamente', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al actualizar warehouse.', { autoClose: 3000 });
		throw new Error(error);
	}
}
);

export const deleteWarehouse = createAsyncThunk('warehouses/deleteWarehouse', async warehouse => {
	try {
		const response = await deleteWarehouseApi(warehouse);
		toast.success('Bodega eliminado exitosamente.', { autoClose: 3000 });
		return { warehouse, ...response };
	} catch (error) {
		toast.error('Error al eliminar warehouse.', { autoClose: 3000 });
		throw new Error(error);
	}
});





export const synchronizeWarehouse = createAsyncThunk('warehouses/synchronizeWarehouse', async () => {
	try {
		const response = synchronizeWarehouseApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});


export const synchronizeWarehouseItems = createAsyncThunk('warehouses/synchronizeWarehouseItems', async ({ warehouse_id, group_code }) => {
	try {
		const response = synchronizeWarehouseItemsApi(warehouse_id, group_code);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});



export const synchronizeWarehouseGroup = createAsyncThunk('warehouses/synchronizeWarehouseGroup', async () => {
	try {
		const response = synchronizeWarehouseGroupApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});


export const getWarehouseGroupExist = createAsyncThunk('warehouses/getWarehouseGroupExist', async ({ establishment_id, group_code }) => {
	try {
		const response = await getWarehouseGroupExistApi(establishment_id, group_code);
		return response;
	} catch (error) {
		throw new Error(error.message);
	}
});

